import { makeStyles } from "@material-ui/core/styles"

const useStyles = makeStyles((theme) => ({
  tabContainer: {
    overflowY: "auto",
    maxHeight: 350,
    ...theme.scrollbarStyles,
  },
  popoverPaper: {
    width: "100%",
    maxWidth: 350,
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(1),
    [theme.breakpoints.down("sm")]: {
      maxWidth: 270,
    },
    [theme.breakpoints.down("xs")]: {
      width: "calc(100vw - 24px)",
      maxWidth: "calc(100vw - 16px)",
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
    },
  },
  elementBar: {
    display: "flex",
    padding: theme.espacamento.spacing300,
    borderRadius: theme.radius.radius300,
    justifyContent: "center",
    alignItems: "center",
    gap: theme.espacamento.spacing300,
    [theme.breakpoints.down("xs")]: {
      minWidth: 44,
      minHeight: 44,
      padding: 8,
    },
  },
  iconBar: {
    color: theme.palette.neutral400,
  },
  mainPaper: {
    flex: 1,
    maxHeight: 500,
    maxWidth: 500,
    padding: theme.spacing(1),
    overflowY: "scroll",
    ...theme.scrollbarStyles,
    [theme.breakpoints.down("xs")]: {
      maxHeight: "min(500px, 70vh)",
      maxWidth: "100%",
    },
  },
  tabIndicator: {
    minWidth: "160px !important",
    [theme.breakpoints.down("xs")]: {
      minWidth: "0 !important",
    },
  },
  tabs: {
    textTransform: "none",
  },
}))

export default useStyles
